(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll("[data-countdown]");

  containers.forEach(container => {
    const timezone = container.dataset.timezone;
    const textToday = container.dataset.textToday;
    const textTomorrow = container.dataset.textTomorrow;
    const textOnMonday = container.dataset.textOnMonday;

    const shipMessageEl = container.querySelector(".shipping-countdown__shipday");
    const countdownEl = container.querySelector(".countdown-time");

    function getSwedishNow() {
      return new Date(
        new Date().toLocaleString("en-US", { timeZone: timezone })
      );
    }

    function getNextDeadline() {
      const now = getSwedishNow();
      const shippingDays = [1, 3, 5]; // Mon, Wed, Fri

      function setDeadline(date) {
        date.setHours(17, 0, 0, 0);
        return date;
      }

      for (let i = 0; i < 7; i++) {
        let candidate = new Date(now);
        candidate.setDate(now.getDate() + i);

        if (shippingDays.includes(candidate.getDay())) {
          candidate = setDeadline(candidate);
          if (candidate > now) return candidate;
        }
      }
    }

    function updateCountdown() {
      const nowSE = getSwedishNow();
      const deadlineSE = getNextDeadline();
      if (!deadlineSE) return;

      const diffMs = deadlineSE - nowSE;
      const diffHours = diffMs / 1000 / 60 / 60;

      // Weekend exception: next deadline is Monday and user's local day is Sat or Sun.
      // In this window we always show the block (bypassing the 24 h cutoff).
      const localDay = new Date().getDay(); // user's local time: 0=Sun, 6=Sat
      const isWeekendException = deadlineSE.getDay() === 1 && (localDay === 6 || localDay === 0);

      if (!isWeekendException && diffHours > 24) {
        container.style.display = "none";
        return;
      }

      container.style.display = "";

      const totalSeconds = Math.floor(diffMs / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      countdownEl.textContent =
        String(hours).padStart(2, "0") + ":" +
        String(minutes).padStart(2, "0") + ":" +
        String(seconds).padStart(2, "0");

      // Label
      if (isWeekendException) {
        shipMessageEl.textContent = localDay === 6 ? textOnMonday : textTomorrow;
      } else {
        const localNow = new Date();
        const todayLocal = new Date(localNow);
        todayLocal.setHours(0, 0, 0, 0);
        const deadlineLocal = new Date(deadlineSE);
        deadlineLocal.setHours(0, 0, 0, 0);
        const diffDays = Math.round((deadlineLocal - todayLocal) / 86400000);
        shipMessageEl.textContent = diffDays === 0 ? textToday : textTomorrow;
      }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});
  } catch(e) { console.error(e); }
})();

})();
